module.exports = __webpack_public_path__ + "static/media/Turning Old Cars into Opportunities.467c3c81.jpg";